/**
 * One-shot in-memory flag used to land on /login while preserving an existing session.
 * Set when an auth-flow surface (e.g. magic-link "token expired" panel, or the
 * "Back to login" button on the reset-password / password-expired screens) wants
 * the user to reach /login even though they still have a valid session for a
 * different account. Without this flag, the auth middleware would bounce the
 * authenticated user straight back to /dashboard.
 */
let authenticatedLoginVisitRequested = false

export const requestAuthenticatedLoginVisit = (): void => {
  if (typeof window === 'undefined') return
  authenticatedLoginVisitRequested = true
}

export const consumeAuthenticatedLoginVisit = (): boolean => {
  if (!authenticatedLoginVisitRequested) return false
  authenticatedLoginVisitRequested = false
  return true
}
